import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { AppShell } from "../components/AppShell"
import { useApi } from "../api/hooks"
import { listTemplates, type TemplateMeta } from "../api/templates"
import { useT, type StringKey } from "../lib/i18n"

export function TemplatesPage() {
  const api = useApi()
  const { t } = useT()
  const [items, setItems] = useState<TemplateMeta[] | null>(null)
  const [err, setErr] = useState<string | null>(null)

  useEffect(() => {
    listTemplates(api)
      .then((r) => setItems(r.items))
      .catch((e: unknown) => setErr(e instanceof Error ? e.message : String(e)))
  }, [api])

  const mine = (items ?? []).filter((m) => !m.public)
  const pub = (items ?? []).filter((m) => m.public)

  return (
    <AppShell>
      <div style={{ display: "flex", alignItems: "center", marginBottom: 16 }}>
        <h1 style={{ margin: 0, fontSize: 28 }}>{t("templates_title")}</h1>
        <Link
          to="/templates/new"
          style={{
            marginLeft: "auto",
            background: "var(--accent)", color: "var(--accent-fg)",
            padding: "8px 14px", borderRadius: 8, fontWeight: 600, fontSize: 13,
          }}
        >
          + {t("templates_upload")}
        </Link>
      </div>
      <p style={{ color: "var(--muted)", maxWidth: 640 }}>{t("templates_intro")}</p>

      {err && <p style={{ color: "#ff7a85" }}>{err}</p>}
      {!err && items === null && <p style={{ color: "var(--muted)" }}>{t("loading")}</p>}

      <Section title={t("templates_public")} list={pub} t={t} />
      {mine.length > 0 && <Section title={t("templates_my")} list={mine} t={t} />}
    </AppShell>
  )
}

function Section({ title, list, t }: {
  title: string
  list: TemplateMeta[]
  t: (k: StringKey, vars?: Record<string, string | number>) => string
}) {
  if (list.length === 0) return null
  return (
    <section style={{ marginTop: 32 }}>
      <h2 style={{ fontSize: 14, color: "var(--muted)", letterSpacing: 1, textTransform: "uppercase" }}>{title}</h2>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))", gap: 16 }}>
        {list.map((m) => (
          <div
            key={m.template_id}
            style={{
              padding: 16,
              border: "1px solid var(--border)",
              borderRadius: 12,
              background: "var(--surface)",
              color: "var(--text)",
            }}
          >
            <p style={{ margin: 0, fontSize: 11, color: "var(--muted)", textTransform: "uppercase", letterSpacing: 1 }}>
              {m.template_id}
            </p>
            <p style={{ margin: "8px 0 4px 0", fontSize: 16, fontWeight: 600 }}>{m.name}</p>
            <p style={{ margin: 0, color: "var(--muted)", fontSize: 12 }}>
              {m.lang.toUpperCase()} · v{m.version} · {t("templates_pages", { n: m.total_pages })}
            </p>
            <div style={{ display: "flex", gap: 8, marginTop: 12 }}>
              <Link
                to={`/forms/${encodeURIComponent(m.template_id)}/main`}
                style={{ flex: 1, textAlign: "center", padding: "6px 10px", borderRadius: 8, fontSize: 13,
                  background: "var(--accent)", color: "var(--accent-fg)", fontWeight: 600 }}
              >
                Apri
              </Link>
              <Link
                to={`/cells/${encodeURIComponent(m.template_id)}/main`}
                style={{ flex: 1, textAlign: "center", padding: "6px 10px", borderRadius: 8, fontSize: 13,
                  border: "1px solid var(--border)", color: "var(--text)" }}
              >
                ✎ Celle
              </Link>
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}
